import { render, staticRenderFns } from "./ChartOfAccounts.vue?vue&type=template&id=3d8571ed&scoped=true"
import script from "./ChartOfAccounts.vue?vue&type=script&lang=js"
export * from "./ChartOfAccounts.vue?vue&type=script&lang=js"
import style0 from "./ChartOfAccounts.vue?vue&type=style&index=0&id=3d8571ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8571ed",
  null
  
)

export default component.exports